import { Injectable } from '@angular/core';
import { IClaimQuestionForm, IClaimQuestionResponse } from '../../interfaces/IContactUs';
import { HttpService } from '../http/http.service';
import { catchError, map, Observable, of } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { DataService } from '../data/data.service';
import { CONTACT_SUBMISSION_API } from '../../utils/api.util';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(private httpService: HttpService, private data: DataService) { }


  /**
     * 
     * @param value @description This method will be used to submit the contact form
     */
  submitContactForm(value: IClaimQuestionForm): Observable<IClaimQuestionResponse> {
    return this.httpService.post<IClaimQuestionResponse>(CONTACT_SUBMISSION_API, value);
  }

}
